import type BubbleRegion from '@/model/UserUse/BubbleRegion'
import { ED } from './eventDescriptionMessages'
import { getEventDescriptionProject } from './eventDescriptionContext'

/** 等同 C# FileClass.GetFileNameEx：取路径文件名 */
export function fileNameEx(path: string | undefined | null): string {
  if (path == null || path === '') return ''
  const s = path.replace(/\\/g, '/')
  const i = s.lastIndexOf('/')
  return i >= 0 ? s.slice(i + 1) : s
}

/** C# Regex.Split(s, @"\\n")[0]：先按字面量 \\n 再按真实换行取首行 */
export function firstLineCs(s: string | undefined | null): string {
  if (s == null || s === '') return ''
  const t = s.split('\\n').join('\n')
  const line = t.split(/\r?\n/)[0] ?? ''
  return line
}

/** C# GameMessageString.TextToNull：空则保持空 */
export function textToNullRef(s: string): string {
  return s.trim() === '' ? '' : s
}

/** 气泡版式名称，等同 GetBubbleLayDescription */
export function bubbleLayDescription(id: number): string {
  const p = getEventDescriptionProject()
  const list: BubbleRegion[] = p?.userRm?.BubbleRegionList ?? []
  const hit = list.find((r) => r.regionId === id)
  return hit?.regionName ?? ''
}

export function personLocationZh(location: number): string {
  if (location === 1) return ED.ZUO
  if (location === 2) return ED.ZHONG
  if (location === 3) return ED.YOU
  return ''
}

/** 动图描述里「动作：」后的片段替换 */
export function normalizeGifActionDescription(desc: string): string {
  const marker = `${ED.DONGZUO}：`
  if (!desc.includes(marker)) return ''
  let str = desc
  str = str.split(ED.XUNHUANBOFANG).join(`[${ED.XUNHUAN}]`)
  str = str.split(ED.GENSUIWENZI).join(`[${ED.WENZI}]`)
  return str
}

export function pad4(n: number): string {
  const v = Math.floor(n) + 1
  return v < 0 ? String(v) : String(v).padStart(4, '0')
}

/** 起名界面（10014）附加说明：从 Input 三元组取标签名 */
export function callMenuInputBoxDescription(input: string | undefined | null): string {
  const raw = input ?? ''
  const parts = raw.split(',')
  const names: string[] = []
  for (let i = 0; i + 2 < parts.length; i += 3) {
    const label = parts[i]?.trim()
    if (label) names.push(label)
  }
  return names.length ? ` ${names.join('、')}` : ''
}
